import React from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { getText } from 'services/languageService';
import { toggleRulerModeAction } from 'store/actions/measurements';
import { TooltipMapIcon } from 'components/UI/TooltipMapIcon';
import { MapElementIcon } from 'components/UI/MapElementIcon';
import { IconButton } from '@mui/material';
import StraightenIcon from '@mui/icons-material/Straighten';

export const RulerElement: React.FC = () => {
  const { ruler } = useAppSelector((state) => state.measurements.mode);

  const dispatch = useAppDispatch();
  const toggleRulerMode = () => {
    dispatch(toggleRulerModeAction());
  };

  return (
    <TooltipMapIcon title={getText('RULER_TL')}>
      <MapElementIcon
        id="ruler-btn"
        sx={{
          backgroundColor: (theme) =>
            ruler ? theme.palette.grey[700] : theme.palette.grey[500],
        }}
        onClick={toggleRulerMode}
      >
        <IconButton>
          <StraightenIcon
            fontSize={'large'}
            sx={{ color: 'white', transform: 'rotate(-45deg)' }}
          />
        </IconButton>
      </MapElementIcon>
    </TooltipMapIcon>
  );
};
